import { forwardRef, type Ref, type SVGProps } from 'react';
import { SvgIcon } from '../../components/icon/icon';

interface SVGRProps {
  title?: string;
  titleId?: string;
}
const Lightning = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    ref={ref}
    aria-labelledby={titleId}
    {...props}>
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M13.972 4h-2.785c-.317 0-.6.2-.706.497L7.466 12.93c-.2.56.3 1.12.88.982l2.018-.48a.75.75 0 0 1 .894.938l-1.355 4.707c-.23.8.821 1.324 1.321.657L17.1 11.9a.75.75 0 0 0-.6-1.2h-2.915a.75.75 0 0 1-.7-1.019l1.788-4.661a.75.75 0 0 0-.7-1.019"
      vectorEffect="non-scaling-stroke"
    />
  </svg>
);
const ForwardRef = forwardRef(Lightning) as SvgIcon;
export { ForwardRef as ReactComponent };
